


































import { Component, Prop } from 'vue-property-decorator';
import CurrencyMixin from '@/components/helpers/currency-mixin';
import { mixins } from 'vue-class-component';
import query from '@/components/query/query-constructor';
import PickerBase from './base';

@Component
export default class ReportSettings extends mixins<CurrencyMixin,PickerBase>(CurrencyMixin, PickerBase) {
  pageSizeList: number[] = [ 50, 100, 200, 500, 1000 ];

  @Prop()
  planLimits: keyof BillingLimits;

  @Prop()
  isCustom: boolean;

  get selectedCurrencyItem() {
    return this.$store.state.currencyList.find((item: any) => item.code === this.$store.getters.tableQueryForCurrentTab.currency);
  }

  getCurrencyCode(code: any) {
    return `${this.currencies[code]} ${code}`;
  }

  get menuListCurrency(): Bemob.ListItem {
    return {
      ...(this.selectedCurrencyItem && {
        title: this.t(this.selectedCurrencyItem.name),
        subtitle:  this.getCurrencyCode(this.selectedCurrencyItem.code),
      }),
      subItems: this.currencyListOrderedPreferred.map((item: any) => ({
        title: item.name,
        subtitle: this.getCurrencyCode(item.code),
        click: () => this.handleSelectCurrency(item.code)
      } as Bemob.ListItem)),
      meta: {
        filter: true
      }
    };
  }

  handleSelectPageSize(value: number) {
    if (this.$store.getters.tableQueryForCurrentTab.limit !== value) {
      this.$store.commit('tableQuery',{
        name: 'limit',
        value: +value
      })

      this.pushURL();
      this.bus.emit('reset-pagination');
    }
  }

  get menuListPageSize(): Bemob.ListItem {
    return {
      title: this.t('Rows Per Page'),
      subtitle:  this.$store.getters.tableQueryForCurrentTab.limit + '',
      subItems: this.pageSizeList.map((item) => ({
        title: item + '',
        click: () => this.handleSelectPageSize(item)
      } as Bemob.ListItem)),
      hidden: this.isLiveVisits
    };
  }

  handleExport() {
    if(this.pick('view') === 'tree' && this.pick('searchBy')==='tags'){
      this.bus.emit('toast-warning', this.t('This report will export to CSV in table format.<br>Downloaded data may differ from treeview report.<br>To preview in CSV, switch report to tableview.'));
    }

    this.bus.emit('open-dialog', { name: 'ExportCSV' });
  }

  get menuListExport() {
    return {
      title: this.t('Export CSV'),
      icon:  'fas fa-file-download',
      click: this.handleExport
    };
  }

  mounted() {
    this.bus.on('report-tab-added', this.onBusReportTabAdded);
    if(!this.isReport()){
      this.applyDataFromUrl()
    }
  }

  beforeDestroy() {
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
  }

  onBusReportTabAdded() {
    // take data from url on active report page
    this.applyDataFromUrl()
  }

  applyDataFromUrl() {
    const routeParams = query.decode(this.$route.params.data as string);
    const { currency, limit } = routeParams;
    this.$store.commit('tableQuery',{
      name: 'currency',
      value: currency || this.$store.state.user.currencyId
    })
    this.$store.commit('tableQuery',{
      name: 'limit',
      value: +limit || 50
    })
  }

  handleSelectCurrency(value) {
    this.$store.commit('tableQuery',{
      name: 'currency',
      value: value
    })
    this.pushURL();
    this.bus.emit('refresh-report');
  }

  get menuList(): Bemob.ListItem[] {
    return ([
      this.menuListCurrency,
      this.menuListPageSize,
      this.menuListExport,
    ] as Bemob.ListItem[]).filter(({ hidden }) => !hidden);
  }
}
